
export enum PricingRulesetOwnerCd {
	BILL_TO = 'BillTo',
	CONSIGNEE = 'Consignee',
	SHIPPER = 'Shipper'}

